import HCLTreeVertexValue from '../../HCLTreeVertexValue/HCLTreeVertexValue';
import Expression, { ExpressionJSON } from '../../HCLTreeVertexValue/Expression';
import Label, { LabelJSON } from '../../HCLTreeVertexValue/Label';

export interface BasicEventVertexValueJSON {
  label: LabelJSON;
  expression: ExpressionJSON;
  source_type: string;
}

class BasicEventVertexValue extends HCLTreeVertexValue {
  private expression: Expression;

  /**
   * @param {Label} label?
   * @param {Expression} expression?
   */
  constructor(label?: Label, expression?: Expression) {
    super(label || new Label('Basic Event', ''));
    this.expression = expression || new Expression();
  }

  /**
   * @returns {Expression}
   */
  getExpression(): Expression {
    return this.expression;
  }

  /**
   * @param {Expression} expression
   */
  setExpression(expression: Expression): void {
    this.expression = expression;
  }

  public getFormattedSubLabel(): string {
    return this.getExpression().toString();
  }

  /**
   * @returns {BasicEventVertexValueJSON} - dictionary object that describes this
   */
  toJSON(): BasicEventVertexValueJSON {
    return ({
      ...super.toJSON(),
      expression: this.expression.toJSON(),
      source_type: 'hcl',
    });
  }

  clone(): HCLTreeVertexValue {
    return new BasicEventVertexValue(this.label.clone(), this.expression.clone());
  }
}

export default BasicEventVertexValue;
